export const reelRankingReducer = (state = {}, action) => {
  switch (action.type) {
    case "GET_REEL_RANKING_LIST_REQUEST": {
      return {
        ...state,
        loading: true,
        reelRankings: null,
      };
    }

    case "GET_REEL_RANKING_LIST_SUCCESS": {
      return {
        ...state,
        loading: false,
        reelRankings: action.payload,
      };
    }

    case "GET_REEL_RANKING_LIST_FAILED": {
      return {
        ...state,
        loading: false,
        reelRankings: action.payload,
      };
    }

    case "UPDATE_REEL_RANKING_REQUEST": {
      return {
        ...state,
        loading: true,
      };
    }

    case "UPDATE_REEL_RANKING_SUCCESS": {
      return {
        ...state,
        loading: false,
        reelRankings: action.payload,
      };
    }

    case "UPDATE_REEL_RANKING_FAILED": {
      return {
        ...state,
        loading: false,
        reelRankings: action.payload,
      };
    }

    default: {
      return state;
    }
  }
};